<template>
  <header id="nav-bar" class="site-header">
    <div class="site-header__inner">
      <a class="brand" @click="navigate('/')">SWIFTORLAND</a>

      <nav class="nav">
        <a
          v-for="item in primary"
          :key="item.path"
          class="nav__link"
          :class="{ 'is-active': isActive(item), 'is-gold': item.gold }"
          @click="navigate(item.path)"
        >
          {{ item.label }}
          <span class="nav__underline"></span>
        </a>

        <div class="nav__more">
          <a
            class="nav__link"
            :class="{ 'is-active': moreOpen || moreIsActive }"
            @click.stop="toggleMore"
          >
            More<span class="nav__caret">&#9662;</span>
            <span class="nav__underline"></span>
          </a>
          <div v-if="moreOpen" class="menu" @click.stop>
            <a
              v-for="item in more"
              :key="item.path"
              class="menu__link"
              :class="{ 'is-active': isActive(item) }"
              @click="navigate(item.path)"
            >{{ item.label }}</a>
          </div>
        </div>
      </nav>

      <div class="site-header__account">
        <login-status></login-status>
      </div>
    </div>
    <div class="site-header__rule"></div>
  </header>
</template>

<script>
export default {
  name: 'nav-bar',
  data () {
    return {
      moreOpen: false,
      primary: [
        { label: 'Home', path: '/' },
        { label: 'Leaderboard', path: '/leaderboard' },
        { label: 'Bets', path: '/bets' },
        { label: 'Craps', path: '/craps' },
        { label: 'Sub Bounties', path: '/bounties' },
        { label: 'GOLD', path: '/gold', gold: true },
        { label: 'Raffles', path: '/ticket-raffles' }
      ],
      more: [
        { label: 'Loot Shop', path: '/loot-shop' },
        { label: 'My Room', path: '/rooms' },
        { label: 'Room Browser', path: '/room-browser' },
        { label: 'Rates', path: '/rates' }
      ]
    }
  },
  computed: {
    moreIsActive () {
      return this.more.some(item => this.isActive(item))
    }
  },
  watch: {
    $route () {
      this.moreOpen = false
    }
  },
  mounted () {
    document.addEventListener('click', this.closeMore)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeMore)
  },
  methods: {
    isActive (item) {
      const path = this.$route.path
      return item.path === '/' ? path === '/' : path.indexOf(item.path) === 0
    },
    toggleMore () {
      this.moreOpen = !this.moreOpen
    },
    closeMore () {
      this.moreOpen = false
    },
    navigate (path) {
      this.moreOpen = false
      if (this.$route.path === path) {
        this.$router.go(0)
      } else {
        this.$router.push({ path })
      }
    }
  }
}
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 500;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  background: linear-gradient(180deg, rgba(12, 12, 15, 0.94), rgba(12, 12, 15, 0.72));
  border-bottom: 1px solid var(--sl-line);
}

.site-header__inner {
  max-width: 1240px;
  margin: 0 auto;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.site-header__rule {
  height: 3px;
  background: linear-gradient(90deg, var(--sl-red), #9a1319 60%, #7a0f14);
}

.site-header__account {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 140px;
}

.brand {
  flex-shrink: 0;
  cursor: pointer;
  user-select: none;
  font-family: var(--sl-font-display);
  font-size: 26px;
  letter-spacing: 1.5px;
  line-height: 1;
  background: linear-gradient(180deg, #ffffff 0%, #cfd2da 45%, #7c8090 55%, #eef0f4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 2px 0 rgba(0, 0, 0, 0.5));
}

.nav {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.nav__link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-family: var(--sl-font-cond);
  font-weight: 700;
  font-size: 14.5px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 8px 12px;
  color: #c4c4cc;
  transition: color 0.15s;
  white-space: nowrap;
}

.nav__link:hover {
  color: #ffffff;
}

.nav__link.is-active {
  color: #ffffff;
}

.nav__link.is-gold {
  color: var(--sl-gold);
}

.nav__link.is-gold:hover {
  color: #ffd97a;
}

.nav__caret {
  font-size: 10px;
  transform: translateY(1px);
}

.nav__underline {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 2px;
  height: 2px;
  border-radius: 2px;
  background: transparent;
}

.nav__link.is-active .nav__underline {
  background: var(--sl-red);
}

.nav__more {
  position: relative;
}

.menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 200px;
  background: var(--sl-surface);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--sl-radius);
  padding: 6px;
  box-shadow: 0 24px 50px rgba(0, 0, 0, 0.6);
  z-index: 60;
}

.menu__link {
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-family: var(--sl-font-cond);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 10px 12px;
  border-radius: 8px;
  color: #c4c4cc;
  box-sizing: border-box;
}

.menu__link:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
}

.menu__link.is-active {
  color: #ffffff;
}

@media (max-width: 1080px) {
  .site-header__inner {
    flex-wrap: wrap;
    padding: 12px 18px;
    gap: 12px;
  }
  .nav {
    order: 3;
    flex: 1 0 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    row-gap: 2px;
  }
  .brand {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation-Bar.vue